import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import IconStyles from "components/icons/Icon.module.scss";

export const GlamgirlFlat = ({size, fill, className, id}) => {
  let _attributes = {};
  _attributes.viewBox = "0 0 48 48";
  _attributes.width = _attributes.height = size || 48;
  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(IconStyles["icon"], className);
  } else {
    _attributes.className = IconStyles["icon"];
  }

  return (
    <svg {..._attributes}>
      <rect className={IconStyles["icon__canvas"]} x={"0"} y={"0"} width={"48"} height={"48"}/>
      <path d="M24,48A24,24,0,0,1,7.029,7.029,24,24,0,0,1,40.97,40.97,23.842,23.842,0,0,1,24,48Zm2.112-32.914c1.025,2.828,2.1,5.844,2.973,8.894a42.809,42.809,0,0,0-2.366,3.664c-1.5,2.6-4.029,7.722-4.021,12.749,0,1.435.368,3.26,2.124,3.81A3.951,3.951,0,0,0,26,44.377,6.066,6.066,0,0,0,29.97,42.66c3.378-3.16,2.8-8.267,2-12.807-.365-2.056-.844-4.161-1.423-6.254a47.019,47.019,0,0,1,3.885-4.132,1.077,1.077,0,0,0,.443-1.027.228.228,0,0,0-.225-.163.86.86,0,0,0-.5.251,26.539,26.539,0,0,0-3.925,3.957,76.5,76.5,0,0,0-3.344-9.13.5.5,0,0,0-.481-.3.85.85,0,0,0-.531.2.267.267,0,0,0-.071-.01.24.24,0,0,0-.237.252,22.3,22.3,0,0,1-1.752,7.764c-.383.848-1.547,3.43-3.32,3.43a2,2,0,0,1-.571-.086c-1.563-.468-1.663-2.229-1.736-3.515v-.006c-.005-.1-.011-.19-.017-.28A19.191,19.191,0,0,1,22.955,6.689a1.422,1.422,0,0,0,.361-1.6A2.453,2.453,0,0,0,21.1,3.921a2.286,2.286,0,0,0-1.521.531c.315-.283.357-.321.358-.324s-.43.38-.539.488a12.261,12.261,0,0,0-.9,1.011l-.034.041a19.919,19.919,0,0,0-1.531,2.16A21.84,21.84,0,0,0,14.611,13a14.074,14.074,0,0,0,1.025,10.679c1.09,2.162,2.3,3.168,3.806,3.168a3.65,3.65,0,0,0,.834-.1,5.618,5.618,0,0,0,3.487-2.621,18.71,18.71,0,0,0,2.348-9.036ZM26,43.049a1.813,1.813,0,0,1-1.468-.638c-1.309-1.573-.346-5.013.229-7.069.051-.183.1-.353.141-.508a34.033,34.033,0,0,1,2.511-6.494A24.407,24.407,0,0,1,29.4,25.1c.46,1.713.814,3.282,1.083,4.8a25.291,25.291,0,0,1,.554,7.23,7.486,7.486,0,0,1-2.412,4.889A4.488,4.488,0,0,1,26,43.049Z" transform="translate(0 0)" fill={fill}/>
    </svg>
  );
};

GlamgirlFlat.defaultProps = {
  size: 48,
  fill: "#fff",
  className: "",
  id: ""
};

GlamgirlFlat.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  fill: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};